/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt"],
  _excluded2 = ["children"];
import "./Icon-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
// TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.
var iconStyles = null;
export var Icon = function Icon(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("img", _extends({
    alt: alt || 'icon'
  }, props, {
    className: ax(["_2rkolb4i _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"])
  }));
};

// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
var akIconWrapperStyles = null;
export var AKIconWrapper = function AKIconWrapper(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_2hwx1i6y"])
  }), children);
};